import { PuntoCliente } from "./punto-cliente.model";

export class PuntoGrupo {

    idGrupo: number;
    descripcion: string;
    observacion: string;

    puntos: object; //new
    check: boolean; //new

    constructor(data: any) {
        console.log(data)
        this.idGrupo = data['id'];
        this.descripcion = data['descripcion'];
        this.observacion = data['observacion'];

        this.puntos = (data['puntos']) ? this.setPuntos(data['puntos']):[]; //new
        this.check = false; //new
    }

    setPuntos(data){
            let puntos = [];
            data.forEach(el => {
                puntos.push(new PuntoCliente(el));
            });
            return puntos;
    }
}